import { Divider, Layout } from 'antd';
import classNames from 'classnames';
import type React from 'react';

import { Logo } from './logo/logo';
import { ProductsMenu } from './products-menu/products-menu';
import { Profile } from './profile/profile';

interface HeaderProps {
  isCalculatorRoute: boolean;
}

export const Header: React.FC<HeaderProps> = ({ isCalculatorRoute }) => (
  <Layout.Header
    className={classNames('flex items-center justify-between', {
      'px-20 sm:px-24 md:px-32 lg:px-24 h-56 sm:h-64 max-sm:fixed left-0 top-0 right-0 z-[3]': isCalculatorRoute,
      'px-24 h-64': !isCalculatorRoute,
    })}
  >
    <Logo isCalculatorRoute={isCalculatorRoute} />

    {!isCalculatorRoute && (
      <div className="flex items-center">
        <Profile />
        <Divider vertical className="border-gray-7 h-32 ml-12 mr-20" />
        <ProductsMenu />
      </div>
    )}
  </Layout.Header>
);
